import Vue from 'vue'
import Vuex from 'vuex'

import general from '@/store/general'
import projects from '@/store/projects'
import reviews from '@/store/reviews'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		general,
		projects,
		reviews,
	},
})
